import React, { Component } from 'react';
import logo from '../assets/image/logo.png';
import '../css/Header.css';

class HeaderLogin extends Component {
  constructor() {
    super();
    this.BaseUrl = "http://klscoop.or.th/";
    this.state = {
      about: { 
        history: this.BaseUrl + 'page.php?pid=1',
        ceo: this.BaseUrl + 'page.php?pid=6',
        staff: this.BaseUrl + 'page.php?pid=7'
      },
      service: {
        member: this.BaseUrl + 'page.php?pid=2',
        scheduleLoan: this.BaseUrl + 'uploads/document/4/20180820944567j2SNIA.pdf',
        example: this.BaseUrl + 'uploads/document/2/201805221549380nUbIba.pdf',
        schedule: this.BaseUrl + 'uploads/document/3/20180522155115z3KGD45.pdf',
        serviceLoan: this.BaseUrl + 'page.php?pid=3',
        info: this.BaseUrl + 'page.php?pid=4'
      },
      performance: this.BaseUrl + 'page.php?pid=26',
      account: this.BaseUrl + 'page.php?pid=19',
      contact: this.BaseUrl + 'contact_map.php'
    };
  }

  render() {
    const currentPath = window.location.pathname
    return (
      <div>
        <div className="fix-content">
          <nav className="navbar navbar-expand-lg navbar-light">
            <div nav="top" className="nav-top">
              <img className="nav-top-logo" src={logo} />
              <div className="nav-top-title-content">
                <div className="tc-1">สหกรณ์ออมทรัพย์สาธารณสุขกาฬสินธุ์ จำกัด</div>
                <div className="tc-2 n-tc-2">Kalasin Public Health Savings Cooperative Limited.</div>
              </div>
            </div>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavDropdown">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a className="nav-link" href={this.BaseUrl}>หน้าแรก</a>
                </li>
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    เกี่ยวกับสหกรณ์
                  </a>
                  <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                    <a className="dropdown-item" href={this.state.about.history}>ประวัติสหกรณ์</a>
                    <a className="dropdown-item" href={this.state.about.ceo}>คณะกรรมการดำเนินการ</a>
                    <a className="dropdown-item" href={this.state.about.staff}>เจ้าหน้าที่สหกรณ์</a>
                  </div>
                </li>
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    บริการสมาชิก
                  </a>
                  <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                    <a className="dropdown-item" href={this.state.service.member}>เกี่ยวกับสมาชิก</a>
                    <a className="dropdown-item" href={this.state.service.scheduleLoan}>ตารางประมาณการชำระหนี้เงินกู้</a>
                    <a className="dropdown-item" href={this.state.service.example}>ตัวอย่างประกันเงินกู้สามัญ</a>
                    <a className="dropdown-item" href={this.state.service.schedule}>ตารางหลักเกณฑ์การกู้เงิน</a>
                    <a className="dropdown-item" href={this.state.service.serviceLoan}>บริการให้กู้</a>
                    <a className="dropdown-item" href={this.state.service.info}>ข้อควรรู้ของสมาชิก</a>
                  </div>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href={this.state.performance}>ผลการดำเนินงาน</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href={this.state.account}>บัญชีธนาคาร</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href={this.state.contact}>ติดต่อเรา</a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
        <div className="nav-dash nav-login">{(currentPath === '/online/register') ? 'สมัครใช้งาน' : 'เข้าสู่ระบบ'}</div>
      </div>
    );
  }
}
export default HeaderLogin;